import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { BeesInvoiceModel } from "../models/BeesInvoiceModel";
import { BeesInvoiceService } from "../services/BeesInvoiceService";

export function useBeesInvoiceVM(token: string, year: number, month: number) {
    const [invoices, setInvoices] = useState<BeesInvoiceModel[]>([]);
    const [startNo, setStartNo] = useState("");
    const [loading, setLoading] = useState(false);
    const [listHash, setListHash] = useState(0);

    const getList = () => {
        setInvoices([]);
        setLoading(true);
        setListHash(Utils.getRandomKey());

        const request = BeesInvoiceService.getList(token, year, month);
        DataUtils.onRequest(request, onResult);
    }

    const onResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success) {
            setInvoices(result.data);
            setListHash(Utils.getRandomKey());
        }

        setLoading(false);
    }

    return {
        invoices,
        startNo, setStartNo,
        loading,
        listHash,
        getList
    }
}